import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler,
  CountryCityService
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { ClientAddressDO } from 'app/BaseFramework/shared/models'

@Component({
  selector: 'exclusions-multi-add-panel',
  templateUrl: './exclusions-multi-add-panel.component.html',
  styleUrls: ['./exclusions-multi-add-panel.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ExclusionsMultiAddPanelComponent),
      multi: true
    }
  ]
})
export class ExclusionsMultiAddPanelComponent implements ControlValueAccessor {
  /**
   * 
   * ControlValueAccessor Implementation
   */
  writeValue(obj: any): void {
    if (obj !== undefined) {
      this.exclusionList = obj;
    }
  }
  propagateChange = (_: any) => { };

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {
  }
  setDisabledState?(isDisabled: boolean): void { }
  _currentComponentName = 'ExclusionsMultiAddPanelComponent'
  constructor(private viewContainerRef: ViewContainerRef,
    public validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    private appMetadataHandler: AppMetadataHandler,
    private countryCityService: CountryCityService) { }

  //Declaraions which might need developer input
  exclusionForm: FormGroup
  EXCLUSIONFORMNAME = "exclusionForm"
  lookupsToBind = ['exclusionEventCd', 'exclusionEventCategoryCd']
  selectorOfThisComponent = 'exclusions-multi-add-panel'
  parentEvent$
  exclusionList: Array<any> = [];
  exclusionType = 'POLICYEXCLUSIONS'
  productExclusionVisibility = false
  policyExclusionVisibility = !this.productExclusionVisibility

  list = [
    1, 2, 3
  ]
  /**
   *
   *  Ninad: Whenever any developer is creating a new Component,
   * please make sure that you copy all import commands, constructor and
   * Boiler and Component Creation Kickstart CODE 
   *
   * 
   * Component Creation Kickstart CODE 
   */

  //ComponentSpecific Inputs, Outputs
  @Output() componentOutput = new EventEmitter<any>();
  @Input() type: string;
  @Input() IO: any;
  @Input() addPanel: any
  private _inputDataForEdit = null;
  @Input()
  set inputDataForEdit(value: any) {
    if (value) {
      this._inputDataForEdit = value
      this.exclusionList = this._inputDataForEdit
    };
  };

  private _useDefaultCountryOnly: boolean = true;
  @Input()
  set useDefaultCountryOnly(value: any) {
    if (value == null || value == undefined)
      this._useDefaultCountryOnly = true
    else
      this._useDefaultCountryOnly = value

  }

  get useDefaultCountryOnly() {
    return this._useDefaultCountryOnly
  }

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
    } catch { }
  }
  getParentComponentName(): string {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
    } catch { }
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      let isOutputValid = this.validateOutput(this.exclusionForm)
      if (isOutputValid)
        this.EmitComponentOutput(this.exclusionForm)
      else {
        this.EmitComponentOutput("ERROR")
      }
    })
  }

  validateOutput(o: FormGroup) {
    this.commonUtilty.markAllFieldDirty(o);
    return o.valid
  }

  //Initializations
  lookup$: any = this.commonUtilty.initializeLookupList(this.lookupsToBind)
  cityCd$: any = this.countryCityService.getProvinceCities(null)

  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
      console.groupEnd();
    }
    this.initializeExclusionForm(this._inputDataForEdit)
    this.initExclusionListForm(this._inputDataForEdit);
    this.detectChangeAndPropogateData(this.exclusionListForm)
    this.subscribeToParentEvent()
    /* Init dummy rows from Input() */
    for (let i = 1; i < this.addRows; i++) { this.addRow() }
    if (!this.addPanel) this.addPanel = "inline-grid"
  }


  /**
   * Form Trasactions
   */

  initializeExclusionForm(data?, isEdit?, index?) {
    let payload = data || {}
    this.exclusionForm = this.fb.group({
      exclusionEventCd: this.validationUtilService.setValidationsForFormControl('exclusionEventCd', this.EXCLUSIONFORMNAME, payload['exclusionEventCd']),
      exclusionEventCategory: this.validationUtilService.setValidationsForFormControl('exclusionEventCategory', this.EXCLUSIONFORMNAME, payload['exclusionEventCategory']),
      exclusionValidity: this.validationUtilService.setValidationsForFormControl('exclusionValidity', this.EXCLUSIONFORMNAME, payload['exclusionValidity']),
      exclusionValidityStartDt: this.validationUtilService.setValidationsForFormControl('exclusionValidityStartDt', this.EXCLUSIONFORMNAME, payload['exclusionValidityStartDt']),
      exclusionValidityExpiryDt: this.validationUtilService.setValidationsForFormControl('exclusionValidityExpiryDt', this.EXCLUSIONFORMNAME, payload['exclusionValidityExpiryDt']),
      isEdit: this.validationUtilService.setValidationsForFormControl('isEdit', this.EXCLUSIONFORMNAME, isEdit),
      index: this.validationUtilService.setValidationsForFormControl('index', this.EXCLUSIONFORMNAME, index)
    })
  }


  @Input() addRows: number = 0;
  rows = [{ id: 1 }];
  // addRow() {
  //   let objDummy = { id: 1 };
  //   this.rows.push(objDummy);
  // }
  // removeRow() {
  //   this.rows.pop();
  // }

  coverages = [
    { id: 4, name: "Premium Waiver" },
    { id: 1, name: "Double Accident Benefit" },
    { id: 2, name: "Personal Accident" },
    { id: 5, name: "Critical Illness" },
    { id: 3, name: "Hospitalization & Surgery" },
  ]

  exclusionListForm: FormGroup;
  initExclusionListForm(data?) {
    let output = data || []
    this.exclusionListForm = this.fb.group({
      exclusions: this.fb.array([])
    });
    this.initilizeExclusionList(output)
  }

  initilizeExclusionList(data) {
    let output = data && (Array.isArray(data) && data.length == 0) ? [{}] : data
    if (this.commonUtilty.isArrayIterable(output)) {
      output.forEach(exclusion => {
        this.addRow(exclusion);
      });
    }
  }
  initExclusionForm(data?, isEdit?, index?): FormGroup {
    let payload = data || {}
    return this.fb.group({
      exclusionEventCd: this.validationUtilService.setValidationsForFormControl('exclusionEventCd', this.EXCLUSIONFORMNAME, payload['event']),
      exclusionEventCategory: this.validationUtilService.setValidationsForFormControl('exclusionEventCategory', this.EXCLUSIONFORMNAME, payload['eventCategoryCd']),
      exclusionValidity: this.validationUtilService.setValidationsForFormControl('exclusionValidity', this.EXCLUSIONFORMNAME, payload['validityType']),
      exclusionValidityStartDt: this.validationUtilService.setValidationsForFormControl('exclusionValidityStartDt', this.EXCLUSIONFORMNAME, payload['exclusionValidityStartDt']),
      exclusionValidityExpiryDt: this.validationUtilService.setValidationsForFormControl('exclusionValidityExpiryDt', this.EXCLUSIONFORMNAME, payload['expiryDt']),
      id: this.validationUtilService.setValidationsForFormControl('exclusionValidityExpiryDt', this.EXCLUSIONFORMNAME, payload['id']),
      remarks: this.validationUtilService.setValidationsForFormControl('remarks', this.EXCLUSIONFORMNAME, payload['remarks']),
      isEdit: this.validationUtilService.setValidationsForFormControl('isEdit', this.EXCLUSIONFORMNAME, isEdit),
      index: this.validationUtilService.setValidationsForFormControl('index', this.EXCLUSIONFORMNAME, index)
    });
  }
  addRow(data?) {
    let dataForEdit = data || {}
    const control = <FormArray>this.exclusionListForm.get('exclusions');
    control.push(this.initExclusionForm(dataForEdit));
  }
  removeRow(index: number) {
    const control = <FormArray>this.exclusionListForm.get('exclusions');
    let removeItem = this.exclusionListForm.value.exclusions[index]

    if (this.commonUtilty.isArrayIterable(this._inputDataForEdit) && removeItem) {
      this._inputDataForEdit.forEach((e, i) => {
        if (e.id == removeItem.id) {
          this._inputDataForEdit.splice(i, 0)
        }
      });
    }

    control.removeAt(index);
  }
  save() {
    console.log(this.exclusionListForm.value);
  }




  detectChangeAndPropogateData(form) {
    form.valueChanges.subscribe(e => {
      console.log('Form Changes', e);
      console.log('Form', form)

      let formData = form.value.exclusions || []
      let outputToPropogate = this._inputDataForEdit
      if (this.commonUtilty.isArrayIterable(formData)) {

        formData.forEach(exclusion => {
          let exclusionIndex = outputToPropogate.findIndex(o => o.id == exclusion.id)
          if (exclusion == -1) {
            let output = {
              eventCategoryCd: exclusion.exclusionEventCategory,
              event: exclusion.exclusionEventCd,
              remarks: exclusion.remarks,
              expiryDt: exclusion.exclusionValidityExpiryDt,
              validityType: exclusion.exclusionValidity
            }
            outputToPropogate.push(output)
          }
          else {
            outputToPropogate[exclusion] = Object.assign({}, outputToPropogate[exclusion], exclusion)
          }
        });
      }

      if (this.commonUtilty.isArrayIterable(outputToPropogate)) {
        this.propagateChange(outputToPropogate)
      }
      else {
        this.propagateChange(this._inputDataForEdit)
      }
    })
  }

  isRequired(fieldName) {
    let returnObj = this.validationUtilService.isRequired(fieldName, this.EXCLUSIONFORMNAME)
    return returnObj
  }
  addExclusion(form) {
    if (form.status === 'VALID') {
      let exclusionDO = {}

      if (form.value.isEdit) {
        exclusionDO = this.exclusionList[form.value.index];
      }

      exclusionDO = this.commonUtilty.deepCopy(form.value);
      // exclusionDO['exculsionEventCategory'] = form.value.exculsionEventCategory;

      if (this.exclusionList) {
        if (form.value.isEdit) {
          this.exclusionList.splice(form.value.index, 1, this.commonUtilty.deepCopy(exclusionDO))
        } else {
          this.exclusionList.push(this.commonUtilty.deepCopy(exclusionDO));
        }
      }
      this.propagateChange(this.exclusionList)
      // this.EmitComponentOutput(this.exclusionList)
    }
  }

  editExclusion(exclusion, index) {
    let isEdit = true;
    this.initializeExclusionForm(exclusion, isEdit, index)
  }

  removeExclusion(index) {
    this.exclusionList.splice(index, 1)
  }

  clearForm() {
    this.initializeExclusionForm()
  }
}
